import { useCallback, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useStore } from "./useStore";
import { refreshActionToken } from "../redux/actions/authActions";
import moment from "moment";

const useShowImage = () => {
  const { authStore } = useStore();
  const dispatch = useDispatch();

  useEffect(() => {
    const token = authStore.token;
    if (!token) return;

    const tokenFile = authStore.token_file;
    if (!tokenFile || !tokenFile.t || tokenFile.wait === true) {
      if ((!tokenFile || !tokenFile.t) && !tokenFile?.wait) {
        dispatch(refreshActionToken() as any);
      }
      return;
    }

    const tokenExpiration = tokenFile.exp;
    if (tokenExpiration && tokenExpiration - moment().unix() < 10) {
      dispatch(refreshActionToken() as any);
    }
  }, [authStore.token, authStore.token_file, dispatch]);

  const getImage = useCallback(
    (imageId?: string) => {
      if (imageId)
        return `${process.env.REACT_APP_BASE_URL}ws-security/images/${imageId}?token=${authStore.token_file.t}`;
      else return "";
    },
    [authStore.token_file.t]
  );

  return getImage;
};

export default useShowImage;

